import type { BrandProfitAndRevenueTableDataQuery } from "@src/__generated__/urql-graphql";
import { BrandProfitModel } from "../../profit/models";
import type { BrandRevenueModel } from "../../revenue/models";

type TBrand = NonNullable<
  BrandProfitAndRevenueTableDataQuery["brandRevenue"]
>["result"][0];

export class BrandProfitAndRevenueModel
  extends BrandProfitModel
  implements BrandRevenueModel
{
  total_invoiced: TBrand["total_invoiced"];
  our_work_billings_for_date_range: TBrand["our_work_billings_for_date_range"];
  filtered_revenue_share: TBrand["filtered_revenue_share"];
  total_revenue_share: TBrand["total_revenue_share"];
  expenses_billings_for_date_range: TBrand["expenses_billings_for_date_range"];
  __subRows: NonNullable<TBrand["brands"]> | undefined;

  constructor(src: TBrand) {
    super(src);
    this.total_invoiced = src.total_invoiced;
    this.our_work_billings_for_date_range =
      src.our_work_billings_for_date_range;
    this.filtered_revenue_share = src.filtered_revenue_share;
    this.total_revenue_share = src.total_revenue_share;
    this.expenses_billings_for_date_range =
      src.expenses_billings_for_date_range;
    this.__subRows = src.brands ?? undefined;
  }
}
